<template>
  <div>
    <div class="container">
      <b-card-group deck>
        <b-card title=""
                img-src="../../../static/img/nosotros/mision.png"
                style="max-width: 20rem; border-width: 0px"
                img-fluid
                img-alt="image"
                img-top
                class="nosotros">
          <h4 slot="header" class="text-center text-uppercase">Misión</h4>
          <b-card-body>
            <p class="card-text parrafos">
              Somos una vicerrectoría que asume el compromiso de planificar,
              gestionar, y asegurar la calidad de todo lo referente a los procesos de
              investigación, innovación, postgrado en la UAPA para contribuir a su
              bienestar particular y al desarrollo socio-económico regional y nacional.
            </p>
          </b-card-body>
        </b-card>
        <b-card title=""
                img-src="../../../static/img/nosotros/vision.png"
                style="max-width: 20rem; border-width: 0px"
                img-fluid
                img-alt="image"
                img-top
                class="nosotros">
          <h4 slot="header" class="text-center text-uppercase">Visi&oacute;n</h4>
          <b-card-body>
            <p class="card-text parrafos">
              Ser un referente de investigación, innovación y postgrado a nivel
              nacional e internacional.
            </p>
          </b-card-body>
        </b-card>
        <b-card title=""
                img-src="../../../static/img/nosotros/valores.png"
                style="max-width: 20rem; border-width: 0px"
                img-fluid
                img-alt="image"
                img-top
                class="nosotros">
          <h4 slot="header" class="text-center text-uppercase">valores</h4>
          <b-card-body>
            <ul class="text-uppercase list-group list-group-flush text-center">
              <li class="list-group-item bg-transparent">Solidaridad</li>
              <li class="list-group-item bg-transparent">Equidad</li>
              <li class="list-group-item bg-transparent">Cooperaci&oacute;n</li>
              <li class="list-group-item bg-transparent">responsabilidad</li>
              <li class="list-group-item bg-transparent">innovaci&oacute;n</li>
              <li class="list-group-item bg-transparent">Pluralismo</li>
              <li class="list-group-item bg-transparent">talento humano</li>
              <li  class="list-group-item bg-transparent">&eacute;tica</li>
              <li  class="list-group-item bg-transparent">calidad</li>
            </ul>
          </b-card-body>
        </b-card>

      </b-card-group>
    </div>
    <div class="clearfix">
      <b-img width="250" height="auto" left src="../../../static/img/nosotros/bg/infizq.png"/>
      <b-img width="250" height="auto" right src="../../../static/img/nosotros/bg/infder.png" alt="right image"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "sobreNosotros",

  }
</script>

<style scoped>
  .nosotros > .card-body {
    border-radius: 25px;
    background-color: #D5D9DE;
    background-color: rgba(240, 244, 249, 0.71);
  }

  .nosotros > .card-header {
    padding: 0rem 0rem;
    margin-bottom: 0;
    background-color: transparent;
    border-bottom: 0px solid transparent;
  }

  p, h1, h2, h4, li {
    font-family: MarkBook-Bold;
  }

  h1, h2, h4 {
    color: #1E3375;
    font-weight: bold;
  }

  li{
    color: #1E3375;
    font-size: medium;
  }
</style>



// WEBPACK FOOTER //
// src/views/frontend/sobrenosotros.vue